<template>
    <b-navbar toggleable="lg" type="dark" variant="info">
        <b-navbar-brand v-on:click="route_to_home_page" class="cursor-pointer"><strong>Simple Technologies</strong>
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-navbar-nav class="ml-auto">
            <!-- <b-nav-item class="navbar-spacing"><span class="white-font"><strong>Explore</strong></span></b-nav-item> -->
            <!-- <b-nav-item class="navbar-spacing"><span class="white-font"><strong>Services</strong></span></b-nav-item> -->
            <!-- Custom Logic if people sign in  -->
            <b-nav-item href="https://authentication.simtekz.com/login?client_id=3l505p8r7gtfsd4upctv22f6nh&response_type=token&scope=email+openid+phone&redirect_uri=https://simtekz.com" class="navbar-spacing"><span class="white-font"><strong>Sign In</strong></span></b-nav-item>
            <!-- Custom Login if people sign up -->
            <b-nav-item href="https://authentication.simtekz.com/signup?client_id=3l505p8r7gtfsd4upctv22f6nh&response_type=token&scope=email+openid+phone&redirect_uri=https://simtekz.com" class="navbar-spacing"><span class="" ><strong>Sign Up</strong></span></b-nav-item>
            <!-- <b-button class="homepage-search-button" v-on:click="search_docker" type="submit">Add New Script</b-button> -->
            <b-nav-item @click="add_new_script()">Add new script</b-nav-item>
        </b-navbar-nav>
    </b-navbar>
</template>

<script>
    export default {
        name: 'Header',
        components: {
        },
        methods: {
            route_to_home_page() {
                this.$router.push({ name: 'Home' }).catch(() => { });
            },
            add_new_script() {
                this.$router.push({ name: 'Upsert', params: { script: "add"} });
            }
        }
    }
</script>
<style scoped>
    .navbar-spacing {
        margin: 0px 0px 0px 10px;
    }

    .cursor-pointer {
        cursor: pointer;
    }
</style>